module.exports = __webpack_public_path__ + "static/media/1munich.36e37046.jpg";